import FqApi from '@/services/fq-api'

export default {
  async getEntity(id, hash) {
    const url = !hash ? `/errorlogs/${id}` : `/errorlogs/${id}?hash=${hash}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getLog(id) {
    const url = `/errorlogs/getLog/${id}`
    const result = await FqApi.get(url)
    return result.data
  }
}
